"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serverless_pagination_1 = require("@soluto-private/serverless-pagination");
const validateJoi_1 = require("./validateJoi");
exports.validatePagination = validateJoi_1.validateJoi(serverless_pagination_1.PaginationSchema);



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/common-event-api-client/node_modules/@soluto-private/base-client/dist/src/util/validatePagination.js